import { createApp } from "vue";
import OfflineTransactionsSection from "./sections/OfflineTransactions/OfflineTransactionsSection.vue";

createApp({
    components: {
        OfflineTransactionsSection
    }
}).mount(".offline-transactions-section");
